import React from 'react';

export default () => (
  <div className="auth__header">
    <span className="auth__header__company">C&C</span>
    <span className="auth__header__subtitle">Claims Handling</span>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/Authentication/components/Header.js